import { Component, OnInit, ViewChild, ElementRef, Input, ViewChildren, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { forkJoin } from 'rxjs';

import { StateService, AuthService } from '../../../services';
import { CustomFilterModel } from '../../../models';
import { FormFunctions } from '../../../functions';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalSearchFilterItemTextComponent } from '../../modals';
import { } from '../../../shared/modals';
import { AuctionLotSearchFilterItemTextModel } from '../../models';

@Component({
    selector: 'auction-search-saved-filters',
    styleUrls: ['./auction-search-saved-filters.component.scss'],
    templateUrl: './auction-search-saved-filters.component.html',
    //host: {'class': 'filter-item-text'},
})
export class AuctionSearchSavedFiltersComponent implements OnInit {

    @Input() model: CustomFilterModel[];

    @Output() applyFilter = new EventEmitter<CustomFilterModel>();
    @Output() deleteFilter = new EventEmitter<CustomFilterModel>();

    constructor(public router: Router, private activatedRoute: ActivatedRoute, public stateService: StateService, private modalService: NgbModal, public authService: AuthService, public formFunctions: FormFunctions) {
        var me = this;
    }

    ngOnInit() {
        var me = this;
    }

    apply(item: CustomFilterModel) {
        // console.log('apply', item);
        this.applyFilter.emit(item);
    }

    remove(item: CustomFilterModel) {
        // console.log('remove', item);
        this.deleteFilter.emit(item);
    }
}
